import React from 'react';
import { useRecentPicks } from '../utils/recentPicks';

/**
 * The <option>s of a plain dropdown, with the person's recent picks of that
 * kind first and the rest in their usual order (utils/recentPicks.js). The
 * dropdown records a pick in its onChange with recordRecentPick.
 *
 *   <select value={projectId} onChange={(e) => { setProjectId(e.target.value); recordRecentPick('project', e.target.value); }}>
 *       <option value="All">All Projects</option>
 *       <RecentOptions kind="project" items={projects} />
 *   </select>
 *
 * `idKey` is what is remembered (an _id where there is one), `valueKey` and
 * `labelKey` what the option holds and shows. Items may also be plain strings.
 */
const read = (item, key) => {
    if (typeof key === 'function') return key(item);
    if (item !== null && typeof item === 'object') return item[key];
    return item;
};

const RecentOptions = ({ kind, items = [], idKey = '_id', valueKey, labelKey = 'name' }) => {
    const recent = useRecentPicks(kind);
    return recent.order(items, (item) => read(item, idKey)).map((item) => {
        const value = read(item, valueKey || idKey);
        return <option key={String(value)} value={value}>{read(item, labelKey)}</option>;
    });
};

export default RecentOptions;
